import Entity from "./entity";

/**
 * Any activity to be saved for future reference.
 *
 * Object representation for a Activity document from the database.
 */
class Activity extends Entity {
  constructor({
    id,
    restaurantId,
    date,
    type,
    data,
    dismissed = false,
    location,
    userId
  } = {}) {
    super({ id: id, restaurantId: restaurantId });
    this.date = date;
    this.type = type;
    // Data must be serializable
    this.location = location;
    this.data = data;
    this.dismissed = dismissed;
    this.userId = userId;
  }

  /**
   * @returns A plain JS object containing the fields as they will be saved to the
   * database.
   */
  _toMap() {
    return {
      id: this.id,
      date: this.date,
      type: this.type,
      data: this.data,
      location: this.location,
      dismissed: this.dismissed,
      userId: this.userId
    };
  }

  /**
   * @param {*} snapData `Activity` document data as a plain JS object
   * snapshot represented by this `Activity`.
   *
   * @returns {Activity} A new instance created from the provided map.
   */
  static _fromMap(snapData) {
    snapData.date = snapData.date
      ? snapData.date.toDate
        ? snapData.date.toDate()
        : snapData.date
      : null;
    let activity = new Activity(snapData);
    return activity;
  }

  /**
   * @returns {string} A `string` representation of the collection to which this
   * `Activity` belongs to.
   */
  get _functionUrl() {
    return "activities";
  }

  get _entityName() {
    return "activity";
  }
  get _collectionName() {
    return `activities`;
  }
}

export default Activity;
